<template lang="html">
  <div>
    <table class="table table-bordered">
        <tbody>
          <tr>
            <td rowspan="3" align="center" valign="middle" width="20%" v-if="player.player.picture">
              <img data-src="holder.js/100x100/text: Foto \n 100x100" class="img-thumbnail" alt=" Foto \n 100x100 [100x100]" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9InllcyI/PjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiPjwhLS0KU291cmNlIFVSTDogaG9sZGVyLmpzLzEwMHgxMDAvdGV4dDogRm90byBcbiAxMDB4MTAwCkNyZWF0ZWQgd2l0aCBIb2xkZXIuanMgMi41LjIuCkxlYXJuIG1vcmUgYXQgaHR0cDovL2hvbGRlcmpzLmNvbQooYykgMjAxMi0yMDE1IEl2YW4gTWFsb3BpbnNreSAtIGh0dHA6Ly9pbXNreS5jbwotLT48ZGVmcy8+PHJlY3Qgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIGZpbGw9IiNFRUVFRUUiLz48Zz48dGV4dCB4PSIzNC45Mjk2ODc1IiB5PSI0NyIgc3R5bGU9ImZpbGw6I0FBQUFBQTtmb250LXdlaWdodDpib2xkO2ZvbnQtZmFtaWx5OkFyaWFsLCBIZWx2ZXRpY2EsIE9wZW4gU2Fucywgc2Fucy1zZXJpZiwgbW9ub3NwYWNlO2ZvbnQtc2l6ZToxMHB0Ij5Gb3RvPC90ZXh0Pjx0ZXh0IHg9IjIzLjY5NTMxMjUiIHk9IjYyIiBzdHlsZT0iZmlsbDojQUFBQUFBO2ZvbnQtd2VpZ2h0OmJvbGQ7Zm9udC1mYW1pbHk6QXJpYWwsIEhlbHZldGljYSwgT3BlbiBTYW5zLCBzYW5zLXNlcmlmLCBtb25vc3BhY2U7Zm9udC1zaXplOjEwcHQiPjEwMHgxMDA8L3RleHQ+PC9nPjwvc3ZnPg==" data-holder-rendered="true" style="width: 100px; height: 100px;">
            </td>
            <td rowspan="3" align="center" valign="middle" width="20%" v-else>
              <img src="/static/flags/4x3/{{player.player.country.code | lowercase}}.svg"
              class="img-rounded img-responsive" style="width: 100px; height: 100px;">
            </td>
            <td align="left" valign="middle" width="10%"><strong>Jugador:</strong></td>
            <td align="left" valign="middle">{{player.player.surname}} {{player.player.mothers_surname}} {{ player.player.name}} {{player.player.middle_name}}</td>
            <td align="left" valign="middle" width="10%"><strong>Ronda:</strong></td>
            <td align="left" valign="middle" width="10%"></td>
          </tr>
          <tr>
            <td align="left" valign="middle"><strong>Categoría:</strong></td>
            <td align="left" valign="middle"><span class="label label-danger">{{player.category.code}}</span></td>
            <td align="left" valign="middle"><strong>País</strong></td>
            <td align="left" valign="middle">{{ player.player.country.name }}</td>
          </tr>
          <tr>
            <td align="left" valign="middle"><strong>Handicap:</strong></td>
            <td align="left" valign="middle">{{player.handicap}}</td>
            <td align="left" valign="middle">&nbsp;</td>
            <td align="left" valign="middle">&nbsp;</td>
          </tr>
        </tbody>
      </table>
  </div>
</template>

<script>
  import configure from '../configure'
  export default {
    props: {
      player: {default: null}
    },
    data: function () {
      return {}
    },
    computed: {
      player_picture() {
        return configure.image_url + this.player.player.picture
      }
    },
    ready: function () {
    },
    methods: {},
    components: {}
  }
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** Player.vue?e86b4f10
 **/